import { Stack } from '@mui/material';
import { Dialog, TextField } from 'components/commons';
import { ChangeDBFormType } from 'components/layout/Sidebar';
import { Control, Controller } from 'react-hook-form';
import ja from 'utils/ja';
interface DialogPrivateDBProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control?: Control<ChangeDBFormType, any, ChangeDBFormType>;
}

const DialogPrivateDB = ({
  open,
  onClose,
  handleConfirm,
  control,
}: DialogPrivateDBProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.setting.private_db.title}
      handleConfirm={handleConfirm}
    >
      <Stack
        sx={{
          width: { xs: '80vw', sm: '520px' },
          gap: '10px',
          padding: '10px',
          '& *': { fontSize: '18px !important' },
        }}
      >
        <Controller
          name='dbId'
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              id='dbId'
              label={ja.setting.db_id.label}
              placeholder={ja.setting.db_id.placeholder}
              require
              error={fieldState.error}
            />
          )}
        />
        <Controller
          name='dbKey'
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              id='dbKey'
              label={ja.setting.db_key.label}
              placeholder={ja.setting.db_key.placeholder}
              require
              error={fieldState.error}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
};
export default DialogPrivateDB;
